import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { toast } from 'react-toastify';
import './form.css';
import moment from 'moment';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';

let count = 0;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()

class ItRental extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company_id: UserObj ? UserObj.company_id : null,
            spocid: UserObj ? UserObj.rec_id : null,
            email: UserObj ? UserObj.email : '',
            notes: '',
            func: [
                {
                    product_type: '',
                    start_date: '',
                    end_date: '',
                },
            ],
            locationSpoc: [],
            location: '',
            location1: '',
            locationError: '',
            notesError: '',
            dynamicFieldError: false,
            locationData: [],
            locationNew: [],
            locationId: null,
            files: null,
            attachmentError: '',
            btnStatus: false,
            selectedFile: undefined,
            selectedFileName: undefined,
            imageSrc: undefined,
            value: ''
        };
    }


    componentDidMount() {
        var LocationSpoc = JSON.parse(userDataLocal12);
        let locationShort = JSON.parse(locationWithShortName)
        this.setState({ locationNew: locationShort })
        this.setState({
            locationData: LocationSpoc,
        });
    }

    changeSelect = (e) => {
        if (!e) {
            this.setState({
                location: null,
                location1: "",
                locationId: "",
                locationError: "",
            });
            return;
        }

        this.setState({
            location: e,
            location1: String(e.label),
            locationId: e.value,
            locationError: "",
        });
    };


    onLocation = e => {
        this.setState({
            location: e?.target?.value,
            location1: String(e.value),
            locationError: '',
        });
    };

    onManType = (e, i) => {
        let tempState = [...this.state.func];
        tempState[i]['product_type'] = e?.value;
        this.setState({
            func: tempState,
            dynamicFieldError: false,
        });
        this.state.func[i].start_date = ""
        this.state.func[i].end_date = ""
    };
    onStartDate = (e, i) => {
        let tempState = [...this.state.func];
        tempState[i]['start_date'] = e?.target?.value;
        this.setState({
            func: tempState,
            dynamicFieldError: false,
        });
    };




    onEndDate = (e, i) => {
        const selectedEndDate = e?.target?.value;
        let tempState = [...this.state.func];
        const startDate = tempState[i]['start_date'];

        // Check if the start date is selected
        if (!startDate) {
            toast.error("Please select the Start Date first.");
            return;
        }

        // Validate that the end date is not earlier than the start date
        if (selectedEndDate < startDate) {
            toast.error("End Date cannot be earlier than Start Date.");
            return;
        }

        // Update the state if all validations pass
        tempState[i]['end_date'] = selectedEndDate;
        this.setState({
            func: tempState,
            dynamicFieldError: false,
        });
    };





    onNotes = e => {
        this.setState({
            notes: e?.target?.value,
            notesError: '',
        });
    };
    removeFormFields(i) {
        let formValues = this.state.func;
        formValues.splice(i, 1);
        this.setState({ formValues });
    }
    resetValue = () => {
        this.setState({
            notes: '',
            location: '',
            func: [
                {
                    product_type: '',
                    start_date: '',
                    end_date: '',
                },
            ],
            locationError: '',
            notesError: '',
            dynamicFieldError: false,
            attachmentError: '',
        });
        count = 0;
        this.setState({
            selectedFile: undefined,
            selectedFileName: undefined,
            imageSrc: undefined,
            value: ''
        })
    };


    handleFile(e) {

        if (e.target.files[0]) {
            this.setState({
                selectedFile: e.target.files[0],
                selectedFileName: e.target.files[0].name,
                imageSrc: window.URL.createObjectURL(e.target.files[0]),
                value: e.target.value,
            });
        }

        // Getting the files from the input
        this.setState({ files: e.target.files });

        if (e.target.files.length > 2) {
            this.setState({ attachmentError: "Attachment can't be more than 2" });
        }
        else if (e.target.files.length <= 2) {
            this.setState({ attachmentError: "" });
        }
    }


    handleSubmit = (e) => {
        e.preventDefault();
        let files = this.state.files;
        let formData = new FormData();
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i]);
            }
        }
        let dynamicFieldError = false;
        let dateError = false;

        this.state.func.forEach((item) => {
            if (!(item.product_type && item.start_date && item.end_date)) {
                dynamicFieldError = true;
            }

            // Date validation
            if (new Date(item.end_date) < new Date(item.start_date)) {
                dateError = true;
                toast.error("End Date cannot be earlier than Start Date.");
            }
        });

        if (this.state.location === null || this.state.location === '') {
            this.setState({ locationError: "Location can't be empty" });
        } else if (dynamicFieldError) {
            this.setState({ dynamicFieldError: dynamicFieldError });
        } else if (dateError) {
            // Prevent submission if date error is found
            return;
        } else if (this.state.files != null && this.state.files.length > 2) {
            this.setState({ attachmentError: "Attachment can't be more than 2" });
        } else {
            e.currentTarget.disabled = true
            let param = {};
            let common_param = {
                company_id: this.state.company_id,
                spoc_id: this.state.spocid,
                email: this.state.email,
                company_name: UserObj.company_name,
                category: 'equipment_rentals',
                company_name: UserObj ? UserObj.company_name : null,
            };
            let body_param = {
                it_rental: this.state.func,
                location_name: this.state.location1,
                notes: this.state.notes,
            };
            param.common_param = common_param;
            param.body_param = body_param;
            // AddRevenue(param, this.props.onClose)
            //     .then(() => {
            //         // success handled by onClose
            //         this.setState({ btnStatus: false });
            //         e.currentTarget.disabled = false;
            //     })
            //     .catch(() => {
            //         // error toast already shown in AddRevenue
            //         this.setState({ btnStatus: false });
            //         e.currentTarget.disabled = false;
            //     });
            // e.currentTarget.disabled = false;
            AddRevenue(param, (success, message) => {
                if (success) {
                    toast.success(message);
                    this.resetValue();
                    if (this.props.onClose) {
                        this.props.onClose();
                    }
                }
                this.setState({ btnStatus: false });
                e.currentTarget.disabled = false;
            });
        }
    };


    render() {
        const selectLocationData = [];
        if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
            this.state.locationSpoc.map(item => {
                if (item.rec_id) {
                    selectLocationData.push({
                        value: item['location_name_zoho'],
                        label: item['location_name_zoho'],
                    });
                }
            });
        }

        const options2 = [
            { value: 'firewall', label: 'Firewall' },
            { value: 'network_switches', label: 'Network Switches ' },
            { value: 'wireless_access_point', label: 'Wireless Access Point' },
            { value: 'video_conferencing_devices', label: 'Video Conferencing Devices' },
            { value: 'tvs', label: 'TVs' },
            { value: 'cctv_setup', label: 'CCTV Setup ' },
            { value: 'access_control', label: 'Access Control' },
            { value: 'furniture', label: 'Furniture' },
        ];
        return (
            <>

                {' '}
                <div className="row">
                    {' '}

                    <div className="col-md-12 mt-2">
                        {' '}
                        <div className="SwFormGroup">
                            <label className="SwFormLabel">Location <span className="Required">*</span></label>
                            <SwSelect
                                name="location"
                                id="rental-location-select"
                                onChange={this.changeSelect}
                                value={this.state.location}
                                options={this.state.locationData}
                                isClearable={false}
                            />
                            <span className="SwTextDanger SwTextSmall">
                                {this.state.locationError}
                            </span>
                        </div>
                    </div>{' '}

                </div>{' '}
                {this.state.func.map((item, index) => {
                    return (

                        <div className=''>
                            <div className="event1 row">
                                {' '}
                                <div className="col-md-12">
                                    {' '}

                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Select Product for Rent <span className="Required">*</span></label>{' '}
                                        <SwSelect
                                            placeholder="Select"
                                            id={`rental-product-select-${index}`}
                                            options={options2}
                                            key={`key1-${index}`}
                                            value={options2.filter(
                                                option => option.value === item.product_type,
                                            )}
                                            onChange={e => this.onManType(e, index)}
                                        />{' '}
                                    </div>
                                    {this.state.dynamicFieldError && !item.product_type && <span className="SwTextDanger SwTextSmall">
                                        {"Product can't be Empty"}
                                    </span>}
                                </div>{' '}

                            </div>
                            <div className="event row">
                                {' '}
                                <div className="col-md-6">
                                    {' '}

                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">Start Date <span className="Required">*</span></label>{' '}
                                        <AntDDatePicker
                                            value={item.start_date ? dayjs(item.start_date, 'YYYY-MM-DD') : null}
                                            format="DD/MM/YYYY"
                                            placeholder="Select start date"
                                            disabledDate={(current) =>
                                                current && current.isBefore(dayjs().startOf('day'))
                                            }
                                            onChange={(date) => {
                                                let tempState = [...this.state.func];

                                                tempState[index].start_date = date
                                                    ? date.format('YYYY-MM-DD')
                                                    : '';

                                                // Reset end date when start date changes
                                                tempState[index].end_date = '';

                                                this.setState({
                                                    func: tempState,
                                                    dynamicFieldError: false,
                                                });
                                            }}
                                            allowClear={false}
                                        />

                                    </div>
                                    {this.state.dynamicFieldError && !item.start_date && <span className="SwTextDanger SwTextSmall">
                                        {"Start Date can't be Empty"}
                                    </span>}

                                </div>
                                <div className="col-md-6">
                                    {' '}

                                    <div className="SwFormGroup">
                                        <label className="SwFormLabel">End date <span className="Required">*</span></label>{' '}
                                        <AntDDatePicker
                                            value={item.end_date ? dayjs(item.end_date, 'YYYY-MM-DD') : null}
                                            format="DD/MM/YYYY"
                                            placeholder="Select end date"
                                            disabledDate={(current) => {
                                                if (!current) return false;

                                                const startDate = item.start_date
                                                    ? dayjs(item.start_date, 'YYYY-MM-DD')
                                                    : null;

                                                // Must select start date first
                                                if (!startDate) return true;

                                                // End date cannot be before start date
                                                if (current.isBefore(startDate, 'day')) return true;

                                                return false;
                                            }}
                                            onChange={(date) => {
                                                if (!item.start_date) {
                                                    toast.error('Please select the Start Date first.');
                                                    return;
                                                }

                                                let tempState = [...this.state.func];

                                                tempState[index].end_date = date
                                                    ? date.format('YYYY-MM-DD')
                                                    : '';

                                                this.setState({
                                                    func: tempState,
                                                    dynamicFieldError: false,
                                                });
                                            }}
                                            allowClear={false}
                                        />

                                    </div>
                                    {this.state.dynamicFieldError && !item.end_date && <span className="SwTextDanger SwTextSmall">
                                        {"End date can't be Empty"}
                                    </span>}

                                </div>
                            </div>{' '}
                            <div className=''>
                                {index == 0 ? (
                                    <div >
                                        {' '}
                                        <button
                                            type="button"
                                            style={count + 1 < options2.length ? { color: "#0571c4" } : { color: "#63b4f2" }}
                                            className="pl-0 btn addMoreIcon flex"
                                            onClick={() => {
                                                let tempState = [...this.state.func];
                                                tempState.push({
                                                    product_type: '',
                                                    start_date: '',
                                                    end_date: '',
                                                });
                                                this.setState({
                                                    func: tempState,
                                                });
                                                {
                                                    count = count + 1;
                                                }
                                            }}
                                            disabled={
                                                count + 1 < options2.length ? false : true
                                            }

                                        >
                                            {' '}
                                            <span>
                                                {' '}
                                                <i
                                                    className="fa fa-plus-circle"
                                                    aria-hidden="true"
                                                />{' '}
                                                Add More
                                            </span>{' '}
                                        </button>{' '}
                                    </div>
                                ) : (
                                    <div className="">
                                        {' '}
                                        <button
                                            type="button"
                                            className="btn removeBtn1 pt-1"
                                            onClick={() => {
                                                this.removeFormFields(index);
                                                {
                                                    count = count - 1;
                                                }
                                            }}
                                        >
                                            {' '}
                                            <span>
                                                {' '}
                                                <i
                                                    className="fa fa-trash"
                                                    aria-hidden="true"
                                                />{' '}
                                            </span>{' '}
                                        </button>{' '}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}

                <div className='row'>
                    <div className="col-md-12 col-xl-12 col-lg-12 mt-3">
                        {' '}
                        <div className="col-md-12 mt-2">
                            <div className="SwFormGroup">
                                <label className="SwFormLabel">Notes</label>{' '}
                                <SwTextArea
                                    rows="4"
                                    id="rental-notes"
                                    value={this.state.notes}
                                    onChange={this.onNotes}
                                />{' '}
                            </div>
                        </div>
                        <span className="SwTextDanger SwTextSmall">
                            {this.state.notesError}
                        </span>

                    </div>{' '}
                </div>


                <div className='row'>
                    <div className="col-md-12 col-xl-12 col-lg-12 mt-3 mb-4">
                        <div className="formManpowerRow">
                            <div className=' d-flex align-items-center notice_text_modalForm' style={{ fontSize: "14px" }}>
                                <img src='img/info_icon_blue.svg' className='pr-2' />
                                The lock-in period will be a minimum of 12 months.
                            </div>
                            <span className="SwTextDanger SwTextSmall">{this.state.attachmentError}</span>
                        </div>
                    </div>
                </div>




            </>
        );
    }
}

export default ItRental;
